import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { EquipmentsService } from './equipments.service';

@Component({
  selector: 'app-equipments-mac-addr-modal',
  templateUrl: './equipments-mac-addr-modal.component.html',
  styles: []
})
export class EquipmentsMacAddrModalComponent {

  @Input() public requiresMacAddress = true;
  @Input() public requiresIpui = false;

  public detail: any;
  public macPattern = /^([0-9A-Fa-f]{2}(:|-|\s|)){5}[0-9A-Fa-f]{2}$/;

  constructor(
    private equipmentsService: EquipmentsService,
    public modal: NgbActiveModal
  ) {
    this.detail = {
      macAddress: null,
      ipui: null,
    };
  }

  public close(): void {
    this.modal.close({
      macAddress: this.detail.macAddress ? this.equipmentsService.cleanMacAddress(this.detail.macAddress) : null,
      ipui: this.detail.ipui ? this.equipmentsService.cleanIpui(this.detail.ipui) : null,
    });
  }
}
